<template>
    <div>
        <ul>
            <!-- <li><a>New Game</a></li> -->
            <!-- <li><a>Save Game</a></li> -->
            <li><a @click.prevent="fullscreen">Fullscreen</a></li>
            <li><a>Reset Desktop</a></li>
            <li><a @click.prevent="clearWindows">Clear Windows</a></li>
            <li><a @click.prevent="clearLocalStorage">Clear Local Storage</a></li>
            <li><a @click.prevent="chapterSelect('/start')">Chapter 01</a></li>
            <li><a @click.prevent="chapterSelect('/chapter-02')">Chapter 02</a></li>

            <!-- <li><a @click.prevent="logout">Log Out</a></li> -->
        </ul>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        methods: {
            ...mapActions('gameOS', [
                'clearWindows'
            ]),

            logout(e) {
                e.stopPropagation();
                this.$store.dispatch('player/logout').then(() => {
                    // https://forum.vuejs.org/t/best-practice-to-change-the-route-vuerouter-after-a-mutation-vuex/5631/9
                    if (!this.$store.getters.error) {
                        this.$router.replace('/login/');
                    }
                });
            },

            clearLocalStorage() {
                // localStorage.clear();
                localStorage.removeItem('Kleptobreaker');
            },

            chapterSelect(newPath){
                this.$router.replace(newPath);
            },

            // fullscreen(e) {
            //     e.stopPropagation();
            //     this.$store.dispatch('gameOS/fullscreen');
            // }

            fullscreen(){
                // https://developers.google.com/web/fundamentals/native-hardware/fullscreen/
                var doc = window.document;
                var docEl = doc.documentElement;

                var requestFullScreen = docEl.requestFullscreen ||
                                        docEl.mozRequestFullScreen ||
                                        docEl.webkitRequestFullScreen ||
                                        docEl.msRequestFullscreen;

                var cancelFullScreen = doc.exitFullscreen ||
                                        doc.mozCancelFullScreen ||
                                        doc.webkitExitFullscreen ||
                                        doc.msExitFullscreen;

                if (!doc.fullscreenElement &&
                    !doc.mozFullScreenElement &&
                    !doc.webkitFullscreenElement &&
                    !doc.msFullscreenElement) {
                        requestFullScreen.call(docEl);
                }
                else {
                    cancelFullScreen.call(doc);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    a:hover {
        color: white !important;
    }

</style>